import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('lead-sales', {
    components: {
        datePicker
    },

    props: ['quote-id', 'user-id', 'client-id', 'quote-assignee', 'create-sale', 'linked', 'can-link'],

    data() {
        return {
            tpOptions: {
                format: 'DD/MM/YYYY',
            },

            filter: {
                from: '',
                to: '',
                type: ''
            },

            createSaleForm: $.extend(true, new Form({
                data: {
                    assignee: this.quoteAssignee,
                    type: '',
                    value: '',
                    qty: '',
                    commission: '',
                    due_on: moment().startOf('today').format("DD/MM/YYYY"),
                    appointment_date: '',
                    note_box: ''
                },

                working: false,
            }), {}),

            editSalesForm: $.extend(true, new Form({
                data: {
                    id: '',
                    assignee: '',
                    type: '',
                    value: '',
                    qty: '',
                    commission: '',
                    due_on: '',
                    appointment_date: '',
                    note_box: ''
                },

                working: false,
            }), {}),

            loading: false,

            setRemoveId: null,

            sales: [],

            columns: []
        };
    },

    mounted() {
        if (this.createSale) {
            $('#new-sale').modal('show');
        }

        this.getSales();
    },

    methods: {
        handleDateSelected (field, value) {
            console.log(1);
            this.createSaleForm.data[field] = value;
            this.editSalesForm.data[field] = value;
        },

        getSales () {
            this.sales = [];

            this.loading = true;

            axios.get('/api/sales/index', {
                params: {
                    quote_id: this.quoteId,
                    user_id: this.userId,
                    ...this.filter
                }
            }).then((response) => {
                this.sales = response.data.sales;

                if (this.filter.from != '' && this.filter.to != '') {
                    let dateStart = moment(this.filter.from, "DD-MM-YYYY");
                    let dateEnd = moment(this.filter.to, "DD-MM-YYYY");
                    let values = [];

                    while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                        values.push({
                            display: dateStart.format('MM/YYYY'),
                            column: dateStart.format('YYYY-MM')
                        });

                        dateStart.add(1,'month');
                    }

                    this.columns = values;
                }

                this.loading = false;
            });
        },

        create () {
            this.createSaleForm.working = true;

            this.createSaleForm.data.id = this.quoteId;
            this.createSaleForm.data.user_id = this.userId;
            this.createSaleForm.data.client_id = this.clientId;

            Http.post('/api/sales/create', this.createSaleForm, {}).then((response) => {
                this.createSaleForm.resetForm();
                this.createSaleForm.resetAlert();

                if (response.status === 200) {
                    this.getSales();

                    $('#new-sale').modal('hide');

                    if (!this.linked && this.canLink) {
                        $('#link-leads').modal('show');
                    }
                }

                this.createSaleForm.working = false;
            });
        },

        remove (id) {
            this.setRemoveId = id;

            $('#sales-remove').modal('show');
        },

        doRemove () {
            $('#sales-remove').modal('hide');

            axios.post('/api/sales/remove', {
                id: this.setRemoveId
            }).then((response) => {
                if (response.status === 200) {
                    this.getSales();
                    this.setRemoveId = null;
                }
            });
        },

        loadEdit (index) {
            let data = {...this.sales[index]};
            
            data.assignee = Number(data.user_id);
            data.commission = data.commission_id;
            
            this.editSalesForm.data = data;
        },

        update () {
            this.editSalesForm.working = true;

            Http.post('/api/sales/update', this.editSalesForm, {}).then((response) => {
                this.editSalesForm.resetAlert();

                if (response.status) {
                    this.getSales();

                    $('#edit-sale').modal('hide');

                    if (!this.linked && this.canLink) {
                        $('#link-leads').modal('show');
                    }
                }

                this.editSalesForm.working = false;
            });
        },

        handleFilterDateSelected (field, value) {
            this.filter[field] = value;
        },

        downloadParameters () {
            let params = [
                'quote_id=' + this.quoteId,
                'export_type=lead'
            ];

            for (let field in this.filter) {
                params.push(field + '=' + this.filter[field]);
            }

            return '?' + params.join('&');
        },

        getAdminsContent (admins) {
            let html = '';
            let percent = Number(100 / admins.length).toFixed(2);

            for (let admin of admins) {
                html += '<strong>'+ admin.first_name + ' ' + admin.last_name + '</strong>: ' + percent + '%<br>';
            }

            return html;
        },

        calculateRollingTotal(parameter) {
            let total = 0;

            for (let sale of this.sales) {
                if (sale[parameter] != undefined) {
                    total += sale[parameter];
                }
            }

            return total;
        }
    },

    computed: {
        totalValue() {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                count += sale.status == 'sale' ? Number(sale.actual_total) : Number(sale.total);
            });

            return count.toFixed(2);
        },

        totalCommission () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                count += sale.status == 'sale' ? Number(sale.actual_commission) : Number(sale.commission);
            });

            return count.toFixed(2);
        },

        totalNcCommission: function () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                count += sale.status == 'sale' ? Number(sale.actual_nc_commission) : Number(sale.nc_commission);
            });

            return count.toFixed(2);
        },

        referrerTotalCommission: function () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                count += Number(sale.referrer_commission);
            });

            return count.toFixed(2);
        }
    },

    watch: {
        sales () {
            Vue.nextTick(() => {
                setTimeout(() => {
                    $('[data-toggle="popover"]').popover({
                        trigger: 'hover',
                        html: true
                    });
                });
            });
        }
    }
});